module.exports = __webpack_public_path__ + "img/medio-bano.0d68ae5b.svg";